import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "card-body p-4" }, [
      _createElementVNode("h3", { class: "fs-18 mb-3" }, "Shopify Theme Development"),
      _createElementVNode("div", { class: "bg-primary p-4 rounded-3 mb-2" }, [
        _createElementVNode("div", { class: "d-flex justify-content-between flex-wrap gap-3" }, [
          _createElementVNode("div", { class: "d-flex align-items-center" }, [
            _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("i", {
                class: "material-symbols-outlined wh-45 lh-45 text-white text-center rounded-circle",
                style: {"background-color":"#4936f5"}
              }, " for_you ")
            ]),
            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative" }, [
              _createElementVNode("span", { class: "fw-medium text-white d-block mb-1" }, "Client"),
              _createElementVNode("h4", { class: "fs-16 text-white mb-0" }, "Innovatech")
            ])
          ]),
          _createElementVNode("div", { class: "d-flex align-items-center" }, [
            _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("i", {
                class: "material-symbols-outlined wh-45 lh-45 text-white text-center rounded-circle",
                style: {"background-color":"#4936f5"}
              }, " attach_money ")
            ]),
            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative" }, [
              _createElementVNode("span", { class: "fw-medium text-white d-block mb-1" }, "Budget"),
              _createElementVNode("h4", { class: "fs-16 text-white mb-0" }, "$25,500")
            ])
          ]),
          _createElementVNode("div", { class: "d-flex align-items-center" }, [
            _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("i", {
                class: "material-symbols-outlined wh-45 lh-45 text-white text-center rounded-circle",
                style: {"background-color":"#4936f5"}
              }, " pace ")
            ]),
            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative" }, [
              _createElementVNode("span", { class: "fw-medium text-white d-block mb-1" }, "Duration"),
              _createElementVNode("h4", { class: "fs-16 text-white mb-0" }, "360 hrs")
            ])
          ])
        ]),
        _createElementVNode("div", { class: "mt-4" }, [
          _createElementVNode("div", {
            class: "progress bg-light",
            style: {"height":"7px"},
            role: "progressbar",
            "aria-label": "danger example",
            "aria-valuenow": "65",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }, [
            _createElementVNode("div", {
              class: "progress-bar bg-danger",
              style: {"width":"65%","height":"7px"}
            })
          ]),
          _createElementVNode("div", { class: "d-flex justify-content-between mt-2" }, [
            _createElementVNode("span", { class: "fw-medium d-block text-body-bg" }, "Progress"),
            _createElementVNode("span", { class: "fw-medium d-block text-body-bg" }, "65%")
          ])
        ])
      ]),
      _createElementVNode("div", { class: "d-flex justify-content-between align-items-center mb-4 flex-wrap" }, [
        _createElementVNode("span", null, "Project Started: Mar 01, 2024"),
        _createElementVNode("span", null, "Project Deadline: Jun 25, 2024")
      ]),
      _createElementVNode("h4", { class: "fs-14" }, "Project Details"),
      _createElementVNode("p", null, " Vestibulum euismod nisi vitae orci placerat, vitae vehicula eros dictum. Phasellus ut pharetra felis. Nulla facilisi. Nullam congue semper nunc, at sodales magna laoreet id. Nullam et lacus vitae ligula pretium suscipit. Fusce nec viverra enim. Sed feugiat gravida nibh sit amet suscipit. Integer tempor sapien eget metus lacinia, nec finibus lacus tincidunt. Sed sodales tellus nec metus aliquam, nec dignissim arcu lobortis. "),
      _createElementVNode("ul", { class: "mb-0" }, [
        _createElementVNode("li", { class: "mb-2" }, " Outline the boundaries and deliverables of the project. "),
        _createElementVNode("li", { class: "mb-2" }, " List team members, their roles, and responsibilities. "),
        _createElementVNode("li", { class: "mb-2" }, " Specify the technology stack and tools to be used for development. "),
        _createElementVNode("li", { class: "mb-2" }, " Break down the project into manageable phases or sprints. "),
        _createElementVNode("li", { class: "mb-0" }, " Outline the design phase, including wireframing, prototyping ")
      ])
    ], -1)
  ]))]))
}